import { GetTokenSilentlyOptions } from '@auth0/auth0-spa-js';

export const getApiToken = (getAccessTokenSilently: (options?: GetTokenSilentlyOptions) => Promise<string>) => {
  return getAccessTokenSilently({
    audience: process.env.REACT_APP_API_AUDIENCE,
    scope: process.env.REACT_APP_API_SCOPE,
  });
}
